module.exports = __webpack_public_path__ + "static/media/reshortLight.da5bf9d7.svg";